import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import LandingPage from "@/components/landing/LandingPage";
import { ServicePage } from "@/components/landing/ServicePage";
import { PrivacyPolicy } from "@/components/landing/PrivacyPolicy";
import { CookiePolicy } from "@/components/landing/CookiePolicy";
import { SERVICE_PAGES } from "@/servicePages";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {SERVICE_PAGES.map((page) => (
          <Route
            key={page.slug}
            path={`/${page.slug}`}
            element={<ServicePage key={page.slug} page={page} />}
          />
        ))}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </BrowserRouter>
  );
}
